<template>
<div>
	<h2>Búsqueda avanzada de monitoreo</h2>
  <br>
  <v-layout>
    <calendar-rq
      label="Fecha desde:"
      :value.sync="filter.report_datetime__gte"
      item_key="official_date"
      filter_name="report_datetime__gte"
      md="3"
      :name="rq_name"
      append_icon="search"
    />
    <calendar-rq
      label="Fecha hasta:"
      :value.sync="filter.report_datetime__lte"
      item_key="official_date"
      filter_name="report_datetime__lte"
      md="3"
      :name="rq_name"
      append_icon="search"
    />

    <select-rq
      class="px-4"
      md="3"
      :name="rq_name"
      :value.sync="filter.f__year"
      f_key="f__year"
      label="Año"
      :items="years"
      append_icon="search"/>
    <select-rq
      class="px-4"
      md="3"
      :name="rq_name"
      :value.sync="filter.f__week"
      f_key="f__week"
      label="Semana"
      :items="weeks"
      append_icon="search"/>
  </v-layout>

  <SimpleCrud
    :headers="headers"
    :name="rq_name"
    :scheme="scheme"
    :canAdd="myPermissions.includes(48)"
    :canWrite="myPermissions.includes(48)"
    :canDelete="myPermissions.includes(48)"
    :canDetail="false">
		<template slot-scope="{ selectedItem }" slot="write-title">{{selectedItem.id?'Modificar reporte de monitoreo':'Agregar reporte de monitoreo'}}</template>
    <template slot-scope="{ selectedItem }" slot="write">
      <online_monitoring_reports_w :selectedItem="selectedItem"/>
    </template>
    <template slot-scope="{ item }" slot="link">
      <fs1 tag="td">
        <a :href="item.link" target="_blank" v-if="item.link">
          <v-icon>insert_drive_file</v-icon>
        </a>
        <a v-else :href="item.file" target="_blank" class="tableM1_file">
          <v-icon >insert_drive_file</v-icon>
        </a>
      </fs1>
    </template>
    <template slot="delete-title">Eliminar informe</template>
    <template slot-scope="{ selectedItem }" slot="deleteAsk">
      <div>
        ¿Está seguro de eliminar "{{selectedItem.name}}"?
      </div>
    </template>
  </SimpleCrud>
</div>
</template>

<script>
import online_monitoring_reports_w from './online_monitoring_reports_w.vue'
import filter from '@/components/mixins/filter';
const thisYear = new Date().getFullYear();
import { weeksInYear } from '@/functions/general.js';

export default {
  mixins:[filter],
  components:{online_monitoring_reports_w},
  data() {
    return {
      current_year:0,
      report_datetime_format:true,
      rq_name:'online_monitoring_reports',
			scheme:{
				link:{ type:'string'},
				file:{ type:'file'},
        critical_asset: {type: 'int'},
        impacted_area: { type: 'int'},
        organization: { type: 'int'},
        name: {type: 'string'},
        report_datetime: {type: 'date'},
			},
      headers:[
				{ text: '', sortable: false, value:'actions'},
				{ text: 'Nombre de Documento', value: 'name'},
				{ text: 'BCEI / Area', value: 'critical_asset_organization'},
				{ text: 'Fecha', value: 'report_datetime'},
				{ text: 'Semana', value: 'week'},
				{ text: 'Año', value: 'year'},
				
				{ text: 'Archivo', value: 'link', class:'width100px' },
      ],
    };
  },
  beforeMount(){
    this.filter.f__year = new Date().getFullYear();
    let d = new Date();
    this.current_year = d.getFullYear();
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
    this.filter.f__week = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
  },
  watch:{ },
  computed:{
    years() {
      const ys = [];
      for (let i = 2019; i < (thisYear+10); i++) ys.push(i);
      return ys;
    },
    weeks() {
      const ys = [];
      for (let i = weeksInYear(this.filter.f__year); i > 0; i--) ys.push(i);
      return ys;
    },
  },
  methods:{

  }
};
</script>
